import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { I18nModule } from '@app/i18n';
import { AuthRoutingModule } from './auth-routing.module';
import { LoginComponent } from './login/login.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ButtonModule } from '@app/components/button/button.module';
import { PlInputModule } from '@app/components/pl-input/pl-input.module';
import { LoaderModule } from '@shared/loader/loader.module';
import { LoginShellComponent } from '@app/auth/login-shell/login-shell.component';
import { ForgotPasswordComponent } from '@app/auth/forgot-password/forgot-password.component';
import { PasswordSetupComponent } from '@app/auth/password-setup/password-setup.component';
import { ErrorDisplayModule } from '@app/components/errorDisplay/errorDisplay.module';
import { ReleaseStageDisplayComponent } from '@app/components/releaseStageDisplay/releaseStageDisplay.component';

@NgModule({
  imports: [
    AuthRoutingModule,
    ButtonModule,
    CommonModule,
    I18nModule,
    MatFormFieldModule,
    MatInputModule,
    PlInputModule,
    ReactiveFormsModule,
    TranslateModule,
    LoaderModule,
    ErrorDisplayModule,
    ReleaseStageDisplayComponent,
  ],
  declarations: [LoginShellComponent, ForgotPasswordComponent, LoginComponent, PasswordSetupComponent],
})
export class AuthModule {}
